import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'Piatto — Accessible Dining Platform';
const SITE_NAME = 'Piatto';

const SEO = ({
  title,
  description,
  image,
  url,
  type = 'website',
  schema,
  noIndex = false,
}) => {
  const formattedTitle = title ? `${title} | Piatto` : DEFAULT_TITLE;
  const truncatedDescription =
    description && description.length > 160
      ? description.slice(0, 157) + '...'
      : description;

  return (
    <Helmet>
      <title>{formattedTitle}</title>

      {truncatedDescription && (
        <meta name="description" content={truncatedDescription} />
      )}

      {url && <link rel="canonical" href={url} />}

      {noIndex && <meta name="robots" content="noindex" />}

      {/* Open Graph */}
      <meta property="og:title" content={formattedTitle} />
      {truncatedDescription && (
        <meta property="og:description" content={truncatedDescription} />
      )}
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={formattedTitle} />
      {truncatedDescription && (
        <meta name="twitter:description" content={truncatedDescription} />
      )}
      {image && <meta name="twitter:image" content={image} />}

      {/* JSON-LD Structured Data — supports a single object or an array of schemas */}
      {schema && (Array.isArray(schema)
        ? schema.map((s, i) => (
            <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
          ))
        : <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
